import { useQuery } from '@tanstack/react-query';

import mapToDropdownOptions from '../../../helpers/mapToDropdownOptions';
import { QueryKeys } from '../../../query.client';
import zonesService from '../../../services/zones/zones.service';
import { useSiteRequirementsQuery } from '../../../shared/hooks/useSiteRequirementsQuery';
import getDefaultZone from '../invitations.helpers';

export function useZoneOptions(siteId: string, hostId: string, invitationZoneId?: string) {
  const { siteRequirements } = useSiteRequirementsQuery('sinein', siteId);

  // Note: This is the equivalent of a guard clause preventing use of the hook if the type is incorrect;
  // given the `useSiteRequirements can return either sign in or sign out requirements.
  const isSignoutRequirements = siteRequirements && 'scanSignoutRequired' in siteRequirements;

  const enabled = !isSignoutRequirements && !!siteId && !!hostId && siteRequirements?.zonesEnabled;

  const { data: zones } = useQuery({
    enabled,
    queryKey: [QueryKeys.ZONE_OPTIONS, siteId, hostId],
    queryFn: () => zonesService.getZonesForHostProfile(siteId, hostId),
    cacheTime: 0,
  });

  const zoneOptions = mapToDropdownOptions(zones);

  const invitationZone = zones?.find((zone) => zone.id === invitationZoneId);

  const defaultZoneForHostGroup = zones?.find((zone) => zone.hostGroups.find((zoneHostGroup) => zoneHostGroup.default));

  const defaultZoneForSite = zones?.find((zone) => zone.default);

  const defaultZone = getDefaultZone(zoneOptions, invitationZone, defaultZoneForHostGroup, defaultZoneForSite);

  return {
    zoneOptions,
    defaultZone,
  };
}
